import React, { useContext } from "react";
import { useFormik } from "formik";
import { Redirect } from "react-router-dom";
import { store } from "../../../store/store";
import { login } from "../../../_services";
import {
  Button,
  Container,
  PasswordInput,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";

const Login: React.FC = () => {
  const { state, dispatch } = useContext(store);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (values) => {
      login(values.email, values.password).then((data) => {
        dispatch({ type: "LOGIN", payload: data });
      });
    },
  });

  return state.loggedIn ? (
    <Redirect to="/" />
  ) : (
    <Container size="xs" py="xl">
      <Title order={1} mb="lg" ta="center">
        Zaloguj do systemu
      </Title>
      <form onSubmit={formik.handleSubmit}>
        <Stack gap="md">
          <TextInput
            label="Adres email"
            type="email"
            id="email"
            name="email"
            required
            placeholder="john@doe.com"
            onChange={formik.handleChange}
            value={formik.values.email}
          />
          <PasswordInput
            label="Hasło"
            id="password"
            name="password"
            required
            placeholder="P@$$w0rd"
            onChange={formik.handleChange}
            value={formik.values.password}
          />
          <Button type="submit" fullWidth mt="sm">
            Zaloguj
          </Button>
        </Stack>
      </form>
    </Container>
  );
};

export default Login;
